import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import SchemaJSONLD from "@/components/shared/SchemaJSONLD";
import SEOHead from "@/components/shared/SEOHead";
import CookieConsent from "@/components/shared/CookieConsent";
import Home from "@/pages/Home";
import Coaching from "@/pages/Coaching";
import Outplacement from "@/pages/Outplacement";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import { PrivacyPolicy, CookiePolicy, TermsConditions } from "@/pages/Legal";

function App() {
  return (
    <div className="App"
         onContextMenu={(e) => {
           // Disable right-click on images to deter casual saving.
           if (e.target && e.target.tagName === "IMG") e.preventDefault();
         }}
         onDragStart={(e) => {
           if (e.target && e.target.tagName === "IMG") e.preventDefault();
         }}
    >
      <SchemaJSONLD />
      <BrowserRouter>
        <SEOHead />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/professional-coaching" element={<Coaching />} />
            <Route path="/expat-outplacement-support" element={<Outplacement />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
